import cx from 'classnames';

type OwnProps = {
  children: React.ReactNode;
  includesEv?: boolean;
};

export default function BottomPaddingForBoxShadow({
  children,
  includesEv = false
}: OwnProps) {
  return (
    <div className={cx('pb-[10px]', includesEv ? 'h-[441px]' : '')}>
      {children}
    </div>
  );
}
